const projectData = [
  {
    id: 6,
    imageURL: "imgs/golbi_thumbnail.png",
    title: "React Subscription Saas + Stripe",
    description: "Golbi.co is a subscription-based web development agency platform built with React. Designed for ongoing client collaboration, it features service browsing, project management tools, and integrated payment processing via the Stripe API. The single-page interface offers a smooth, modern user experience tailored for scalable digital services.",
    tech: [
      {
        icon_file: "react.svg",
        icon_tooltip: "React"
      },
      {
        icon_file: "nextjs.svg",
        icon_tooltip: "Next.js"
      },
      {
        icon_file: "cloudinary.svg",
        icon_tooltip: "Cloudinary"
      },
      {
        icon_file: "auth0.svg",
        icon_tooltip: "Auth0"
      },
      {
        icon_file: "strapi.svg",
        icon_tooltip: "Strapi"
      },
      {
        icon_file: "stripe.svg",
        icon_tooltip: "Stripe"
      },
    ],
    gitURL: "https://github.com/dinardavis/golbi",
    liveDemoURL: "https://golbi.co/",
  },
  {
    id: 5,
    imageURL: "imgs/travel_thumbnail.png",
    title: "Travel Dashboard Application",
    description: "Built with React, the Travel Dreams Dashboard concept allows users to enter the name of a city that they wish to travel to, and via multiple API requests, receive information such as travel advisory updates, current flight prices, weather info, and a populated image gallery to inspire a future getaway. Users also can create their own profile to login, connect with friends, and share social posts about their adventures!",
   tech: [
      {
        icon_file: "react.svg",
        icon_tooltip: "React"
      },
      {
        icon_file: "nodejs.svg",
        icon_tooltip: "Node.js"
      },
      {
        icon_file: "mongodb.svg",
        icon_tooltip: "MongoDB"
      },
      {
        icon_file: "npm.svg",
        icon_tooltip: "NPM"
      },
      {
        icon_file: "material-ui.svg",
        icon_tooltip: "Material UI"
      },
    ],
    gitURL: "https://github.com/dinardavis/travel_app",
    liveDemoURL: "https://dinardavis.github.io/travel_app/",
  },
  {
    id: 4,
    imageURL: "imgs/dac_thumbnail.png",
    title: "React Corporate Website",
    description: "Custom multipage website, created for a California based nonprofit law firm. The site features individually tailored data files for easy content management. It is also equipped with a bespoke interfaces to gather user info, and file uploading, to allow for in-app career application submissions, newsletter sign-up, and direct contact to individual organizational departments, all utilizing integration with the EmailJS api.",
    tech: [
      {
        icon_file: "react.svg",
        icon_tooltip: "React"
      },
      {
        icon_file: "javascript.svg",
        icon_tooltip: "JavaScript"
      },
      {
        icon_file: "emailjs.svg",
        icon_tooltip: "EmailJS"
      },
      {
        icon_file: "html5.svg",
        icon_tooltip: "HTML 5"
      },
      {
        icon_file: "css3.svg",
        icon_tooltip: "Material UI"
      },
    ],
    gitURL: "https://github.com/dinardavis/dac_website",
    liveDemoURL: "https://dinardavis.github.io/dac_website/",
  },
  {
    id: 3,
    imageURL: "imgs/donutmissit_thumbnail.png",
    title: "Gatsby Static SPA",
    description: "A single page application built using the Gatsby framework, utilizing its server side rendering to generate fast loading images and small file sizes. Also incorporated fetch API calls to populate various site images.",
    tech: [
      {
        icon_file: "gatsby.svg",
        icon_tooltip: "GatsbyJS"
      },
      {
        icon_file: "react.svg",
        icon_tooltip: "react"
      },
      {
        icon_file: "javascript.svg",
        icon_tooltip: "JavaScript"
      },
    ],
    gitURL: "https://github.com/dinardavis/donut_miss_out",
    liveDemoURL: "https://dinardavis.github.io/donut_miss_out/",
  },
  {
    id: 2,
    imageURL: "imgs/suitsupply_thumbnail.png",
    title: "E-Commerce Retail Site",
    description: "This e-commerce site built with React and published using Heroku and Vercel features a headless CMS (Strapi), fully functional user login with integrated Auth0 authentication, shopping cart checkout, order history, and purchase confirmation. Also, the suits look really nice!",
    tech: [
      {
        icon_file: "react.svg",
        icon_tooltip: "React"
      },
      {
        icon_file: "nextjs.svg",
        icon_tooltip: "Next.js"
      },
      {
        icon_file: "cloudinary.svg",
        icon_tooltip: "Cloudinary"
      },
      {
        icon_file: "auth0.svg",
        icon_tooltip: "Auth0"
      },
      {
        icon_file: "strapi.svg",
        icon_tooltip: "Strapi"
      },
      {
        icon_file: "stripe.svg",
        icon_tooltip: "Stripe"
      },
    ],
    gitURL: "https://github.com/dinardavis/suitsupply",
    liveDemoURL: "https://suitsupply.vercel.app/",
  },
  // {
  //   id: 1,
  //   imageURL: "imgs/spacexclone_thumbnail.png",
  //   title: "Landing Page Clone",
  //   description: "Created with HTML, CSS, and Vanilla JavaScript, the goal of this project was to create a SpaceX landing page clone as true to the actual website as possible. My clone is fully responsive, and includes links to the corporate site, offering a complete and seamless user experience.",
  //   tech: [
  //     {
  //       icon_file: "javascript.svg",
  //       icon_tooltip: "JavaScript"
  //     },
  //     {
  //       icon_file: "html5.svg",
  //       icon_tooltip: "HTML 5"
  //     },
  //     {
  //       icon_file: "css3.svg",
  //       icon_tooltip: "Material UI"
  //     },
  //   ],
  //   gitURL: "https://github.com/dinardavis/spacex_clone",
  //   liveDemoURL: "https://dinardavis.github.io/spacex_clone/",
  // },
]

export default projectData

